import { createTheme as createMuiTheme } from '@material-ui/core/styles';

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    neutral: Palette['primary'];
    green: Palette['primary'];
    orange: Palette['primary'];
    gray: Palette['primary'];
    blue: Palette['primary'];
  }
  interface PaletteOptions {
    neutral: PaletteOptions['primary'];
    green: PaletteOptions['primary'];
    orange: PaletteOptions['primary'];
    gray: PaletteOptions['primary'];
    blue: PaletteOptions['primary'];
  }
}

// A custom theme for this app
const theme = createMuiTheme({
  overrides: {
    MuiButton: {
      contained: {
        boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      },
    },
  },
  palette: {
    neutral: {
      main: '#553E4C',
      light: '#5c5c5c',
    },
    green: {
      main: '#039590',
    },
    orange: {
      main: '#D77552',
    },
    gray: {
      main: '#8A8A8A',
      light: '#8A8A8A',
    },
    blue: {
      main: '#5777A3',
    },
    primary: {
      main: '#2F4858',
    },
    secondary: {
      main: '#DFA01F',
      contrastText: '#FFF',
    },
    success: {
      main: '#4caf50',
    },
    error: {
      main: '#F30000',
    },
    background: {
      default: '#EDF1F4',
      paper: '#fff',
    },
    text: {
      primary: '#383836',
      // secondary: '#fff',
    },
    action: {
      active: '#4A4A4A',
      //c54141
    },
  },
  typography: {
    fontFamily: [
      '"IRANSans"',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  direction: 'rtl',
});

export default theme;
